import { tv } from "@ui/lib/tv";
import { srcSet } from "@ui/utils/image";
import { type IllustrationName, illustrationMap } from "./illustrations";

const illustration = tv({
  base: "pointer-events-none select-none",
});

export interface IllustrationProps {
  alt?: string;
  className?: string;
  name: IllustrationName;
}

export function Illustration({ alt = "", className, name }: IllustrationProps) {
  const densitySet = illustrationMap[name];

  return (
    <img
      alt={alt}
      aria-hidden={alt === "" ? "true" : undefined}
      className={illustration({ className })}
      src={densitySet.x1}
      srcSet={srcSet(densitySet.x1, densitySet.x2, densitySet.x3)}
    />
  );
}
